import React, {Component} from 'react';

class MessageWrapper extends Component {

	constructor(props) {
		super(props);
	}

	handeMessageEvent(event) {
		this.props.onMessageEvent && this.props.onMessageEvent(event);
	}

	componentDidMount() {
		this.props.onMessageEvent && window.addEventListener("message", this.handeMessageEvent.bind(this));
	}

	componentWillUnmount() {
		this.props.onMessageEvent && window.removeEventListener("message");
	}

	render() {
		return this.props.children;
	}
}	

export default MessageWrapper;


// WEBPACK FOOTER //
// ./src/components/ContainerWrapper.js